import React, { useEffect, useRef, useState } from "react";
import { enqueueSnackbar } from "notistack";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import { DeleteOutline } from "@mui/icons-material";

export default function FilePicker({
  onSelect,
  label,
  allowedTypes,
  sizeLimit,
  multiple = false,
  setIsLoading,
  disabled,
  boxStyle = {},
  buttonStyle = {},
  listStyle = {},
  initialFiles = [],
}) {
  const inputRef = useRef(null);
  const [key, setKey] = useState(0);
  const [selectedFiles, setSelectedFiles] = useState(initialFiles);

  useEffect(() => {
    setSelectedFiles(initialFiles);
  }, [initialFiles]);

  useEffect(() => {
    if (!selectedFiles?.length) inputRef.current.value = "";
  }, [selectedFiles]);

  const handleSelect = (newFiles) => {
    if (setIsLoading) setIsLoading(true);

    // eslint-disable-next-line no-restricted-syntax
    for (const file of newFiles) {
      // Check file type
      if (allowedTypes && !allowedTypes.includes(file.type)) {
        enqueueSnackbar(
          JSON.stringify({
            icon: "error",
            title: "Error",
            text: "Incorrect file type!",
          }),
          {
            variant: "custom",
          }
        );
      }

      // Check file size
      if (sizeLimit && file.size > sizeLimit) {
        enqueueSnackbar(
          JSON.stringify({
            icon: "error",
            title: "Error",
            text: "File size too large!",
          }),
          {
            variant: "custom",
          }
        );
      }
    }

    // Set state with valid files only
    setSelectedFiles([...newFiles]);

    onSelect(multiple ? newFiles : newFiles[0]);

    if (setIsLoading) setIsLoading(false);
  };

  const handleDelete = (fileToDelete) => {
    const filteredList = selectedFiles.filter((f) => f !== fileToDelete);
    setSelectedFiles(filteredList);
    onSelect(filteredList);
    setKey((prevKey) => prevKey + 1);
  };

  return (
    <MDBox sx={boxStyle} mt={3}>
      <MDButton disabled={disabled} color="gray80" component="label" sx={buttonStyle}>
        {label}
        <input
          ref={inputRef}
          key={key}
          type="file"
          multiple={multiple}
          accept={allowedTypes.join(",")}
          onChange={(e) => handleSelect(e.target.files)}
          hidden
        />
      </MDButton>

      <MDBox sx={listStyle} mt={3}>
        {selectedFiles.map((file) => (
          <MDBox display="flex" alignItems="center" justifyContent="space-between" key={file.name}>
            {file.name}
            <DeleteOutline
              sx={{ cursor: "pointer", marginLeft: 4 }}
              color="error"
              onClick={() => handleDelete(file)}
            />
          </MDBox>
        ))}
      </MDBox>
    </MDBox>
  );
}

FilePicker.defaultProps = {
  allowedTypes: [],
  sizeLimit: null,
  multiple: false,
  disabled: false,
  label: "Upload",
  boxStyle: {},
  buttonStyle: {},
  listStyle: {},
  initialFiles: [],
};
